import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Colors
import { statusPalette } from 'components/core/colors';
// Custom
import APPCONFIG from 'constants/Config';
import AppIcon from 'components/icons/AppIcon';

// From Webpack Env Config
const APP_VERSION = __APP_VERSION__; // eslint-disable-line no-undef

const OpacFooter = ({ webSocketOpen }) => (
  <footer>
    <div className="d-flex justify-content-end align-items-center px-3 py-2">
      <span>
        Copyright ©
        {' '}
        <a className="brand" target="_blank" rel="noopener noreferrer" href={APPCONFIG.productLink}>{APPCONFIG.crCompany}</a>
        {' '}
        {APPCONFIG.year}
      </span>
      <span className="mx-2">|</span>
      <span className="mr-2">{APP_VERSION}</span>
      {webSocketOpen
        ? <AppIcon id="wsOpen" color={statusPalette.success} />
        : <AppIcon id="wsClosed" color={statusPalette.warning} />}
    </div>
  </footer>
);

OpacFooter.propTypes = {
  webSocketOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  webSocketOpen: state.webSocket.open,
});

module.exports = connect(
  mapStateToProps,
  null,
)(OpacFooter);



// WEBPACK FOOTER //
// ./components/footer/OpacFooter.js